import { render, staticRenderFns } from "./ReportGeneratedNotification.vue?vue&type=template&id=1e5a13fb&scoped=true&"
import script from "./ReportGeneratedNotification.vue?vue&type=script&lang=js&"
export * from "./ReportGeneratedNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5a13fb",
  null
  
)

export default component.exports